/* eslint-disable */
import {
  LOGIN_PAGE_UNLOADED,
  USER_REGISTER,
  REGISTER_PAGE_UNLOADED,
  LOGIN,
  ASYNC_START,
  UPDATE_FIELD_AUTH,
  USER_INVITE
} from "../constants/actionTypes";

export default (state = {}, action) => {
  switch (action.type) {
    case LOGIN_PAGE_UNLOADED:
      return {
        ...state,
        tags: action.payload
      };
    case USER_REGISTER:
      return {
        ...state,
        tags: action.payload
      };
    case LOGIN_PAGE_UNLOADED:
    case REGISTER_PAGE_UNLOADED:
      return {};
    case ASYNC_START:
      if (action.subtype === LOGIN || action.subtype === USER_REGISTER) {
        return { ...state, inProgress: true };
      }
      return {};
    case USER_INVITE:
      return {
        ...state,
        tags: action.payload
      };
    case UPDATE_FIELD_AUTH:
      return { ...state, [action.key]: action.value };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/reducers/home.js